{
  "ascending": "تصاعدي",
  "ascendingSort": "ترتيب حسب العمود {columnName} بترتيب تصاعدي",
  "collapse": "طي",
  "columnSize": "{value} بالبكسل",
  "descending": "تنازلي",
  "descendingSort": "ترتيب حسب العمود {columnName} بترتيب تنازلي",
  "expand": "تمديد",
  "resizerDescription": "اضغط على مفتاح Enter لبدء تغيير الحجم",
  "select": "تحديد",
  "selectAll": "تحديد الكل",
  "sortable": "عمود قابل للترتيب"
}
